import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import SubString from 'add-ellipsis';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../../components/reduxFields';
import { resetFiltersAndSorting, alertConfirmation, showFormatedDateandTime, VIP } from '../../../../../../actions/utilAction';
import { deleteNotes, NotesList, MarkedAsReviewPatientNote } from './actions/notesActions';
import NotesModal from './Add_Notes_Modal';
import SortingCustom from '../../../../../../components/SortingCustom';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import Tooltip from '../../../../../../components/Tooltip';

class Notes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openNotesModal: false,
            notesId: null,
            patientId: props.patientId ? props.patientId : null,
        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.setSortColumn = this.setSortColumn.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearchNotes = this.handleSearchNotes.bind(this);
        this.handleResetButton = this.handleResetButton.bind(this);
    }

    componentDidMount = () => {
        this.loadData()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_Notes && nextProps.saved_Notes !== this.props.saved_Notes) {            
            this.loadData();
        }
    }

    loadData = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { searchText: this.filter.searchText ? this.filter.searchText : undefined },
            pageNumber: page_number || 1,
        };      
        this.props.NotesList(searchObj, this.state.patientId)
    }

    handleSearchChange(event) {
        if (event.target.value.length > 1) {
          this.filter.searchText = event.target.value;
          this.loadData();
        } else if (event.target.value.length === 0) {
          this.filter.searchText = '';
          this.loadData();
        }
      }
    
    handleResetButton() {
        Alert.closeAll();
        this.props.dispatch(reset('NotesForm'));        
        resetFiltersAndSorting(this.filter, 'id', true);       
        this.loadData();
      }
    
    handleSearchNotes(event) {
        // event.preventDefault();
        // console.log('ServiceCode............',event.ServiceCode);
    
        // if (event.ServiceCode != undefined) {
    
        //   this.filter.searchText = event.ServiceCode;
        //   let searchObj = {
        //     sort_fields: this.filter.sort_Column ? this.filter.sort_Column : '-id',
        //     contain_filters: { serviceCode: this.filter.searchText },
        //     page_number: 1,
        //     includes: 'include=masterunittype,masterroundingrules',
        //   };
    
        //   this.props.getServiceCodeBySearchText(searchObj);
        // } else {
        //   this.filter.searchText = '';
        //   this.loadData();
        // }
      }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        }
    }

    handleOpen = () => {
        Alert.closeAll();
        this.setState({
            openNotesModal: true,
            notesId: null
        });
    };

    handleClose = () => {
        this.setState({
            openNotesModal: false
        })
        this.filter.searchText = '';
    }


    handleEditClick = (e, obj) => {
        Alert.closeAll();
        this.setState({
            openNotesModal: true,
            notesId: obj.id
        });
    }

    handleDeleteClick = (e, obj) => {
        alertConfirmation('Are you sure you want to delete this note?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    handleAlertClick = (event, notesId) => {
        this.props.deleteNotes(notesId, this.state.patientId);
        Alert.closeAll();
    }

    handleMarkedAsReviewPatientNoteClick = (e, obj) => {
        alertConfirmation('Are you sure you want to mark as reviewed this note?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertMarkedAsReviewPatientNoteClick,
                id: obj.id,
            },
        });
    }

    handleAlertMarkedAsReviewPatientNoteClick = (event, notesId) => {
        this.props.MarkedAsReviewPatientNote(notesId, this.state.patientId);
        Alert.closeAll();
    }

    renderData = (notesList) => {
        notesList = notesList || [];
        if (!notesList.length) {
            return (
                <tr>
                    <td colSpan="7">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return notesList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td width="10%">{Obj.title}</td>
                    <td width="20%">
                        {Obj.notes && Obj.notes.length > 0 ?
                            <Tooltip Description={Obj.notes} />
                            : null}
                        {Obj.notes != null && Obj.notes.length > 25 ? SubString(Obj.notes, 25) : Obj.notes != null ? Obj.notes : 'N/A'}
                    </td>
                    <td width="15%">{Obj.lastModifiedFirstName} {Obj.lastModifiedLastName}</td>
                    <td width="15%">{showFormatedDateandTime(Obj.lastModifiedDate)}</td>
                    <td width="25%">{Obj.reviewedBy}</td>
                    <td width="10%" className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                    <td width="5%">
                        {!Obj.isReviewedByMe && <button onClick={(e) => this.handleMarkedAsReviewPatientNoteClick(e, Obj)} type="button" title="Mark As Review" className="tbactionbtn bluefont"><i className="fa fa-bookmark-o" aria-hidden="true"></i></button>}
                        {this.props.updatePermissionNotes && <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>}
                        {this.props.deletePermissionNotes && <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>}
                    </td>
                </tr>
            )
        })

    }

    renderNotesTabs = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { notesList } = this.props;
        let NotesList = (notesList && notesList.data) || [];
        let NotesMeta = (notesList && notesList.meta) || null
        return (
            <div className="readmin-panel">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="10%"><SortingCustom noSort={!NotesList.length} setSortColumn={this.setSortColumn} columnName='Title' displayName='Title' /></th>
                                            <th width="20%">Description</th>
                                            <th width="15%">Last Modified By</th>
                                            <th width="15%">Last Modified Date</th>
                                            <th width="25%">Reviewed By</th>
                                            <th width="10%">Is Active</th>
                                            <th width="5%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(NotesList)}
                                    </tbody>
                                </table>
                                {
                                    NotesMeta && NotesMeta['totalPages']
                                        ?
                                        <PaginatorCustom data={NotesMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                        :
                                        null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    render() {
        const { handleSubmit } = this.props;
        return (
            <div>               
                <div className="modalwindow">
                    <div className="row">
                        <div className="col-sm-5">
                            {this.props.addPermissionNotes && <RaisedButton
                                style={{ marginTop: '10px', marginBottom: '10px' }}
                                label="Add Notes"
                                primary={true}
                                onTouchTap={() => this.handleOpen()} />}
                        </div>
                        <div className="col-sm-7">
                        <div className="row end-flex">
                            <div className="col-sm-6 mtm-27">
                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchNotes)}>
                                <Field
                                name="Note"
                                floatingLabelText="Search"
                                maxLength='10'
                                onChange={this.handleSearchChange}
                                style={{ marginTop: '10px', marginBottom: '10px' }}
                                component={renderTextField}
                                />
                            </form>
                            </div>
                            <div className="reset-btn col-sm-3 btn_rt">
                            <RaisedButton onTouchTap={this.handleResetButton}  style={{ marginTop: '10px', marginBottom: '10px' }} className="grey_btn">Reset</RaisedButton>

                            </div>
                        </div>
                        </div>
                    </div>
                    {
                        this.state.openNotesModal && <NotesModal
                            notesId={this.state.notesId}
                            patientId={this.state.patientId}
                            closeDialog={() => this.handleClose()} />
                    }
                    </div>
                    {this.renderNotesTabs()}
            </div>
        )
    }
};

Notes = reduxForm({
    form: 'NotesForm',
})(Notes); 

function mapStateToProps(state) {
    return {
        loading: state.patient_notes.loading,
        notesList: state.patient_notes.notesList,
        saved_Notes: state.patient_notes.saved_Notes,
        deleted_Notes: state.patient_notes,
        markedAsReviewed_Notes: state.patient_notes.markedAsReviewed_Notes,
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    }
}

export default connect(mapStateToProps, { deleteNotes, NotesList, MarkedAsReviewPatientNote })(Notes);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Notes/index.js